export default {
    methods: {
        //VALIDATION/CONFIRMATION
        validateDataForms() {
            let isValid = true;
            for (let input in this.l_inputs) {
                let isValidInput = this.l_inputs[input].validate_input() ? this.l_inputs[input].validate_input() : false;
                if (!isValidInput) {
                    isValid = false;
                }
            }
            return isValid;
        },
        async confirmDisregardChanges(title = null, body = null, buttons = [], byDefault = true) {
            try {
                let res = byDefault;
                if (this.isChangedLocalRecord) {
                    res = await app.activePage.openConfirm(
                        title ? title : this.defaultConfirmDisregardChangesTitle,
                        body ? body : this.defaultConfirmDisregardChangesBody,
                        buttons.length > 0 ? buttons : this.defaultConfirmDisregardChangesButtons
                    );
                }
                return res;
            } catch (err) {
                throw err;
            }
        },
    }
}
